import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_web-presence-404/artifacts/dkbqs7vn_logo.png" 
              alt="Ruminating Room" 
              className="h-12 w-12 mb-4 object-contain"
            />
            <p className="text-white/60 text-sm leading-relaxed">
              A bridal and couture creative agency delivering virtual try-on, 98% accurate garment visuals, and luxe campaign imagery.
            </p>
          </div>
          
          <div>
            <h3 className="text-white text-sm tracking-wider mb-4">EXPLORE</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-white/60 text-sm hover:text-white transition-colors">
                  Fashion Visuals
                </Link>
              </li>
              <li>
                <Link to="/animation" className="text-white/60 text-sm hover:text-white transition-colors">
                  Animation IP
                </Link>
              </li>
              <li>
                <a href="#contact" className="text-white/60 text-sm hover:text-white transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-white text-sm tracking-wider mb-4">CONNECT</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2 text-white/60 text-sm">
                <Mail size={16} />
                <span>contact.ruminatingroom@gmail.com</span>
              </li>
              <li className="flex items-center space-x-2 text-white/60 text-sm">
                <Phone size={16} />
                <span>+91 98765 43210</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="pt-8 border-t border-white/10">
          <p className="text-white/40 text-xs text-center">
            © 2025 Ruminating Room. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
